import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMix12D: IAbstractModule = {
    type: IModuleType.mixZ12D,
    name: 'Z Mix 12 Double',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "3",
                connector: "3",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "4",
                connector: "4",
                cell_size_id: 4,
                accessible: false,
            },
            {
                name: "5",
                connector: "5",
                cell_size_id: 4,
                accessible: false,
            },
            {
                name: "6",
                connector: "6",
                cell_size_id: 4,
                accessible: false,
            },
        ],
        [
            {
                name: "7",
                connector: "7",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "8",
                connector: "8",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "9",
                connector: "9",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "10",
                connector: "10",
                cell_size_id: 4,
                accessible: false,
            },
            {
                name: "11",
                connector: "11",
                cell_size_id: 4,
                accessible: false,
            },
            {
                name: "12",
                connector: "12",
                cell_size_id: 4,
                accessible: false,
            },
        ],
    ]
};
